import React from 'react';
import styled from 'styled-components';
import { useToast } from 'contexts/ToastContext';
import { theme } from 'styles/theme';

/**
 * 토스트 — 색상은 theme 토큰 (ConfirmDialog와 동일 팔레트)
 */

const ToastWrapper = styled.div`
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

function typeColor(type) {
  switch (type) {
    case 'success':
      return theme.colors.status.success;
    case 'error':
      return theme.colors.status.error;
    case 'warning':
      return theme.colors.status.warning;
    case 'info':
    default:
      return theme.colors.blue;
  }
}

const ToastMessage = styled.div`
  min-width: 300px;
  max-width: 500px;
  padding: 12px 20px;
  margin-bottom: 10px;
  background-color: ${theme.colors.white};
  color: ${theme.colors.text.primary};
  border-radius: ${theme.borderRadius.md};
  border: 3px solid ${(p) => typeColor(p.type)};
  box-shadow: ${theme.shadows.md};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  pointer-events: auto;
  animation: slideDown 0.3s ease-out;
  white-space: pre-line;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &:hover {
    opacity: 0.9;
    box-shadow: ${theme.shadows.lg};
  }
`;

const ToastContainer = () => {
  const { currentMessages, closeToast } = useToast();

  if (!currentMessages || currentMessages.length === 0) {
    return null;
  }

  return (
    <ToastWrapper>
      {currentMessages.map((message) => (
        <ToastMessage
          key={message.id}
          type={message.type}
          onClick={() => closeToast(message.id)}
        >
          {message.message}
        </ToastMessage>
      ))}
    </ToastWrapper>
  );
};

export default ToastContainer;
